export default __webpack_public_path__ + "static/media/profile.b35cd16a.png";